"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedMimeTypes = exports.maxImageFileSize = exports.maxImageDimension = exports.env = exports.ckeditorEmojiUrl = void 0;
var maxImageFileSize = 5242880; // 5MB

exports.maxImageFileSize = maxImageFileSize;
var maxImageDimension = 8000;
exports.maxImageDimension = maxImageDimension;
var supportedMimeTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
exports.supportedMimeTypes = supportedMimeTypes;
var ckeditorEmojiUrl = 'https://cdn.jsdelivr.net/emojione/assets/png/';
exports.ckeditorEmojiUrl = ckeditorEmojiUrl;
var env = {
  CONTROL: 'control',
  DESTINATION: 'destination'
};
exports.env = env;